export default class AnimateScroll {
	constructor() {
		this.init();
	}

	init() {
		let elements = document.querySelectorAll('[data-animate-scroll]');
		elements.forEach( (element) => {
			element.addEventListener( 'click', (e) => {
				let target = element.getAttribute( 'href' );

				if ( target.indexOf('#') === -1 ) {
					return;
				}

				e.preventDefault();

				var scroll = new SmoothScroll();
	            var anchor = document.querySelector(target);

	            scroll.animateScroll(anchor, null, { 
	                speed: 1000,
	                easing: 'easeInOutQuad',
	                offset: 100
	            } );
			} );
		} );
	}
}
